const QRCode = ({ signingRef, id, stamp }) => {


    return signingRef && id && stamp ?
        <div>
            <img className="signature-process__container__card__qr-code" src={`/futur-qr-code?applicationid=${id}&signingReference=${signingRef}&rndm=${stamp}`} />
         </div>
     : null;
}

export default QRCode;